import React, { useState } from 'react';
import { useController } from './controller';
import { useParticles } from './particles';
import * as S from './styles';
import DefaultLoading from '../../components/DefaultLoading';
import { translations, LanguageKeys } from './translation';
import { Helmet } from "react-helmet"

const LandingPage = (props: any) => {
    const controller = useController();

    return (
        <S.mainContainer>
            <Helmet>
                <meta name="keywords"
                    content="plataforma de estudos com IA, aprendizado personalizado, flashcards inteligentes, testes personalizados, análise de aprendizado, sessões de estudo, rastreador de progresso, estudar com IA, LearnArez, inteligência artificial para educação, IA para estudantes, gerador de flashcards, planejador de estudos, assistente de aprendizado, aprendizado rápido, aprendizado acelerado, plataforma adaptativa, tutor inteligente, ferramentas de estudo online" />
                <meta name="description"
                    content="O LearnArez é uma plataforma de estudos inteligente com IA, que oferece sessões personalizadas, flashcards inteligentes e testes sob medida para tornar seu aprendizado mais rápido, fácil e eficiente." />
                <meta name="category"
                    content="Educação, Inteligência Artificial, Ferramentas de Aprendizado" />
                <meta property="og:description"
                    content="O LearnArez é uma plataforma de estudos inteligente com IA, que oferece sessões personalizadas, flashcards inteligentes e testes sob medida para tornar seu aprendizado mais rápido, fácil e eficiente." />
            </Helmet>
            <S.loginHeader>
                <S.headerButtonsWrapper>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/login')}>
                        {translations['PTBR'].ctaButtonLogin}
                    </S.headerButton>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/register')}>
                        {translations['PTBR'].ctaButtonRegister}
                    </S.headerButton>
                </S.headerButtonsWrapper>
            </S.loginHeader>
            <S.mainInfo>
                <S.mainTitle>
                    {translations['PTBR'].mainTitle}
                </S.mainTitle>
                <S.subTitle>
                    {translations['PTBR'].subTitle}
                </S.subTitle>
                <S.startCta onClick={() => controller.general.GoToRoute('/register')}>
                    {translations['PTBR'].ctaButton}
                </S.startCta>
            </S.mainInfo>
        </S.mainContainer>
    )
}

const MountedComponent = (props: any) => {
    const particles = useParticles();

    return (
        <>
            <LandingPage />
            <S.particles
                id="tsparticles"
                particlesLoaded={particles.particlesLoaded as any}
                options={particles.options}
            />
        </>
    )
}

export default MountedComponent;